import React, { useState, useEffect } from 'react';
import { ShieldCheck, Cpu } from 'lucide-react';

const AdminLogin = () => {
  const [ipStatus, setIpStatus] = useState('checking'); 
  const [userIp, setUserIp] = useState('');
  // Added state to track inputs
  const [formData, setFormData] = useState({ adminId: '', passcode: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setIpStatus('allowed');
  }, []);

  // NEW: Function to talk to Django
  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('/api/admin-login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-SECUWALL-NODE-ID': 'Alpha-9-Shield',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        // Store the token (Token Auth or JWT)
        localStorage.setItem('adminToken', data.token);
        // Redirect to your Dashboard
        window.location.href = '/portal-gate-001/dashboard';
      } else {
        setError(data.error || 'Invalid Admin Credentials');
      }
    } catch (err) {
      setError('Backend Server Unreachable');
    } finally {
      setLoading(false);
    }
  };

  if (ipStatus === 'checking') {
    return (
      <div className="min-h-screen bg-[#020D08] flex items-center justify-center">
        <div className="text-center space-y-4 font-mono text-green-500">
          <Cpu className="animate-spin mx-auto mb-4" size={40} />
          <p className="animate-pulse tracking-[0.3em]">SECURE HANDSHAKE IN PROGRESS...</p>
        </div>
      </div>
    );
  }


  return (
    <div className="min-h-screen bg-[#020D08] flex items-center justify-center px-6">
      <div className="w-full max-w-md border border-green-500/20 rounded-xl bg-white/[0.02] p-8 backdrop-blur-md">
        <div className="text-center mb-8">
          <ShieldCheck className="mx-auto text-green-500 mb-4" size={48} />
          <h2 className="text-2xl font-bold text-white uppercase italic tracking-wider">SecuWall Admin</h2>
          {error && <p className="text-red-500 text-xs mt-2 font-mono uppercase">{error}</p>}
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <input 
            type="text" 
            required
            placeholder="ADMIN ID" 
            value={formData.adminId}
            onChange={(e) => setFormData({...formData, adminId: e.target.value})}
            className="w-full bg-black/50 border border-green-500/30 rounded p-3 text-white font-mono focus:border-green-500 outline-none transition-all"
          />
          <input 
            type="password" 
            required
            placeholder="PASSCODE" 
            value={formData.passcode}
            onChange={(e) => setFormData({...formData, passcode: e.target.value})}
            className="w-full bg-black/50 border border-green-500/30 rounded p-3 text-white font-mono focus:border-green-500 outline-none transition-all"
          />
          <button 
            disabled={loading}
            className="w-full bg-green-500 text-black font-bold py-3 rounded hover:bg-green-400 disabled:bg-green-800 disabled:cursor-not-wait transition-colors uppercase tracking-widest"
          >
            {loading ? 'Authenticating...' : 'Enter System'}
          </button>
        </form>

        <div className="mt-6 text-center text-[10px] text-green-500/50 font-mono flex justify-between">
          <span>ORIGIN: {userIp}</span>
          <span className="text-green-500 uppercase">Authorized Zone</span>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;